// extracted by mini-css-extract-plugin
export var caption = "Image-module--caption--jtP9L";
export var component = "Image-module--component--D8PRN";
export var credit = "Image-module--credit--izLsh";
export var link = "Image-module--link--syf7C";